export default "__VITE_ASSET__68a452f6__"